<section class="container-fluid flex-column grow">
    <h2 [i18n]="titleKey"></h2>
    <div class="flex-column">
        <label [i18n]="searchTitleKey"></label>
        <div class="flex-row filter">
            <input type="text"
                   class="form-control input-lg"
                   [(ngModel)]="this.search"
                   (ngModelChange)="filterDisplayedTypes()"
                   [i18n]="[{target: 'attribute:placeholder', key: searchPlaceholderKey}]">
            <button *ngIf="canCreateDecarbonizationTypes"
                    class="btn btn-lg btn-primary m-l"
                    type="button"
                    (click)="openTypeCreationModal.emit()">
                <i class="fa fa-plus m-r"></i>
                <span [i18n]="typeCreationButtonKey"></span>
            </button>
            <button *ngIf="canManageRegionDecarbonizationTypes"
                    class="btn btn-lg btn-primary m-l"
                    type="button"
                    (click)="openRegionTypeAddModal.emit()">
                <i class="fa fa-plus m-r"></i>
                <span [i18n]="typeAddRegionButtonKey"></span>
            </button>
        </div>
        <spacer [size]="8"></spacer>
    </div>
    <div class="ibox float-e-margins">
        <div class="ibox-content no-padding">
            <div class="table-responsive list">
                <table class="table table-striped text-left">
                    <tbody>
                    <tr *ngFor="let type of displayedTypes" class="scrollable-list">
                        <td>
                            <span>{{type.label}}</span>
                            <span *ngIf="canManageRegionDecarbonizationTypes
                    && type.regionId != null
                    && regionsNameMap.hasOwnProperty(type.regionId)">
                        - {{regionsNameMap[type.regionId]}}
                    </span>
                        </td>
                        <td>
                            <div *ngIf="canCreateDecarbonizationTypes && removableTypeIdsMap[type.id]"
                                 class="text-right">
                                <button class="btn btn-outline-secondary btn-sm pull-right no-margins"
                                        (click)="deleteItem.emit(type)">
                                    <i style="color: red" class="fa fa-trash"></i>
                                </button>
                            </div>
                            <div *ngIf="canManageRegionDecarbonizationTypes && removableTypeIdsMap[type.id]"
                                 class="text-right">
                                <button class="btn btn-outline-secondary btn-sm pull-right no-margins"
                                        (click)="removeRegionItem.emit(type)">
                                    <i style="color: red" class="fa fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</section>
